import { useState } from "react";

const COUNTS = [5, 6, 7, 8, 9, 11];
export const EMPTY_TEAM = { name: "", age_group: "", sport: "football", format: "flag", player_count: 7, colors: { primary: "#FF6B00", secondary: "#FFFFFF" }, offense_positions: [], defense_positions: [] };

function Toggle({ options, value, onChange, testId }) {
  return (
    <div className="flex flex-wrap gap-2" role="radiogroup" data-testid={testId}>
      {options.map(([v, l]) => (
        <button type="button" key={v} role="radio" aria-checked={value === v} onClick={() => onChange(v)} className={`btn min-w-[52px] ${value === v ? "btn-primary" : "btn-ghost"}`} data-testid={`${testId}-${v}`}>{l}</button>
      ))}
    </div>
  );
}

function LabelList({ label, value, onChange, testId }) {
  const [text, setText] = useState(value.join(", "));
  const commit = () => onChange(text.split(",").map((s) => s.trim().toUpperCase().slice(0, 6)).filter(Boolean));
  return (
    <div>
      <label className="label">{label}</label>
      <input className="input" value={text} onChange={(e) => setText(e.target.value)} onBlur={commit} placeholder="QB, RB, C, WR…" data-testid={testId} />
      <p className="text-xs text-slate-500 mt-1">Separate with commas. Up to 6 letters each. Leave empty for standard labels.</p>
    </div>
  );
}

export function TeamForm({ value, onChange, showLabels }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <div className="space-y-5" data-testid="team-form">
      <div className="grid sm:grid-cols-2 gap-4">
        <div><label className="label" htmlFor="tname">Team name</label><input id="tname" className="input" required maxLength={60} value={value.name} onChange={(e) => set("name", e.target.value)} placeholder="e.g. Tigers" data-testid="team-name-input" /></div>
        <div><label className="label" htmlFor="tage">Age group</label><input id="tage" className="input" maxLength={30} value={value.age_group} onChange={(e) => set("age_group", e.target.value)} placeholder="e.g. U10" data-testid="team-age-input" /></div>
      </div>
      <div><label className="label">Type of football</label><Toggle options={[["flag", "Flag"], ["tackle", "Tackle"]]} value={value.format} onChange={(v) => set("format", v)} testId="team-format" /></div>
      <div><label className="label">Players per side</label><Toggle options={COUNTS.map((c) => [c, String(c)])} value={value.player_count} onChange={(v) => set("player_count", v)} testId="team-count" /></div>
      <div className="flex gap-6">
        {[["primary", "Main color"], ["secondary", "Second color"]].map(([k, l]) => (
          <div key={k}><label className="label">{l}</label>
            <input type="color" value={value.colors[k]} onChange={(e) => set("colors", { ...value.colors, [k]: e.target.value })} className="h-11 w-20 rounded-lg bg-transparent border border-[#1F3358] cursor-pointer" data-testid={`team-color-${k}`} />
          </div>
        ))}
      </div>
      {showLabels && (
        <div className="grid sm:grid-cols-2 gap-4">
          <LabelList label="Default offense labels" value={value.offense_positions} onChange={(v) => set("offense_positions", v)} testId="team-offense-labels" />
          <LabelList label="Default defense labels" value={value.defense_positions} onChange={(v) => set("defense_positions", v)} testId="team-defense-labels" />
        </div>
      )}
    </div>
  );
}
